'use client';

import { useEffect } from 'react';

/**
 * Stamps `data-hydrated` on the <html> element once React has hydrated the client tree.
 *
 * Server-rendered pages are visible before they are interactive: until hydration
 * completes, clicks on elements with React-attached handlers are silently lost.
 * Automation (E2E tests) waits for this attribute before interacting with the page.
 */
function HydrationMarker() {
  useEffect(() => {
    document.documentElement.dataset.hydrated = 'true';
  }, []);

  return null;
}

export { HydrationMarker };
